<template>
    <div @click="resetSessionTimeout" @keydown="resetSessionTimeout">
        <div
            style="
                position: absolute;
                top: 0;
                right: 10px;
                color: #fff;
                z-index: 1000;
                font-size: 1.1rem;
                cursor: pointer;
            "
            v-if="selectedTestCase"
        >
            <span :class="{ transparent: !testCaseVisible }" @click="toggleTestCaseVisibility">{{
                selectedTestCase.name
            }}</span>
        </div>

        <v-app>
            <NavBar />
            <v-main>
                <Stepper v-if="showStepper" />
                <div class="wrapper" style="margin-bottom: 50px">
                    <router-view></router-view>
                    <Footer />
                </div>
            </v-main>
        </v-app>
        <SessionTimeoutModal :showModal="showSessionTimeoutModal" />
    </div>
</template>

<script>
    import NavBar from "@/components/layout/NavBar.vue"
    import Footer from "@/components/layout/Footer.vue"
    import { sessionService } from "@/service"
    import SessionTimeoutModal from "@/components/modal/SessionTimeoutModal.vue"
    import CancelFlowModal from "@/components/modal/CancelFlowModal.vue"
    import { mapState } from "vuex"
    import debounce from "lodash/debounce"

    export default {
        name: "App",
        components: {
            CancelFlowModal,
            SessionTimeoutModal,
            NavBar,
            Footer,
        },
        mounted() {
            sessionService.addEventListener("showSessionTimeoutModal", () => {
                if (!this.showSessionTimeoutModal) {
                    this.showSessionTimeoutModal = true
                    this.showCancelModal = false
                }
            })

            sessionService.addEventListener("resetTimeout", () => {
                if (this.showSessionTimeoutModal) {
                    this.showSessionTimeoutModal = false
                }
            })
        },
        data() {
            return {
                showSessionTimeoutModal: false,
                showCancelModal: false,
                testCaseVisible: true,
            }
        },

        computed: {
            showStepper() {
                return this.$route.meta?.stepper !== false
            },

            ...mapState("testCase", {
                selectedTestCase: state => state.selectedTestCase,
            }),
        },
        methods: {
            resetSessionTimeout: debounce(function () {
                sessionService.resetSessionTimeout()
            }, 500),

            toggleTestCaseVisibility() {
                this.testCaseVisible = !this.testCaseVisible
            },
        },
    }
</script>
<style lang="scss" scoped>
    .wrapper {
        margin: auto;
        max-width: 770px;

        @media #{map-get($display-breakpoints, "lg-and-up")} {
            max-width: 1050px;
        }
    }

    .fix-bottom {
        position: fixed;
        bottom: 10px;
    }

    .v-main {
        padding-bottom: 64px;
    }
</style>
